/**
 * Zoryn FormCreate factory.
 * Adapter forked from @form-create/element-ui (MIT) — https://github.com/xaboy/form-create
 */
import zorynFormCreate from './core/index'

const FormCreate = zorynFormCreate()

const maker = FormCreate.maker

export { maker, zorynFormCreate }

export default FormCreate
